<div class="left-side">
  <div class="header">
    <img class="logo" [src]="logos?.header" />
    <ds-lib-language-picker [(language)]="language" (languageChange)="onLanguageChange($event)">
    </ds-lib-language-picker>
  </div>
  <div class="login-container">
    <h3 mat-subheader-1 class="prevent-select">
      {{ resetmode ? ('dsLibCommon.login.resetTitle' | translate) : ('dsLibCommon.login.login' | translate) }}
    </h3>

    <!-- Reset password template-->
    <ng-container *ngIf="resetmode; else loginTemplate">
      <ds-lib-reset-password [token]="token" (backlogin)="switchResetMode()"></ds-lib-reset-password>
    </ng-container>
    <!-- End Reset password template-->

    <!-- Login password template-->

    <ng-template #loginTemplate>
      <mat-horizontal-stepper class="no-padding" [linear]="true" #stepper>
        <mat-card-content>
          <form [formGroup]="loginForm">
            <mat-step [stepControl]="loginControl">
              <div layout="row">
                <mat-form-field class="contain-icon">
                  <mat-icon class="primary">account_circle</mat-icon>
                  <input
                    matInput
                    placeholder="{{ 'dsLibCommon.login.email' | translate }}"
                    formControlName="login"
                    type="text"
                    required
                  />
                  <!-- Errors required -->
                  <mat-error *ngIf="loginControl.errors?.required">
                    {{ 'dsLibCommon.login.requiredLogin' | translate }}
                  </mat-error>
                  <!-- Errors valid Login -->
                  <mat-error *ngIf="loginControl.errors?.email">
                    {{ 'dsLibCommon.login.validLogin' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
            </mat-step>
            <mat-step [stepControl]="passwordControl">
              <div class="disabled-login">
                <mat-icon class="primary">account_circle</mat-icon>
                <span class="disabled">{{ loginControl.value }}</span>
              </div>
              <ds-lib-input-password
                [placeholder]="'dsLibCommon.login.password' | translate"
                [errorMessage]="'dsLibCommon.login.requiredPassword' | translate"
                [formControlPassword]="passwordControl"
              >
              </ds-lib-input-password>
            </mat-step>
          </form>
        </mat-card-content>
      </mat-horizontal-stepper>

      <ng-container *bydFeatureFlags="'sso_feature'; else submitWithoutSso">
        <ds-lib-login-button
          [title]="selectedStep(0) ? ('dsLibCommon.login.next' | translate) : ('dsLibCommon.login.connect' | translate)"
          [disabled]="selectedStep(0) ? loginControl.invalid : loginForm.invalid || showSpinner"
          [showSpinner]="showSpinner"
          (loginClick)="nextStep()"
        >
        </ds-lib-login-button>
      </ng-container>
      <ng-template #submitWithoutSso>
        <ds-lib-login-button
          [title]="selectedStep(0) ? ('dsLibCommon.login.next' | translate) : ('dsLibCommon.login.connect' | translate)"
          [disabled]="selectedStep(0) ? loginControl.invalid : loginForm.invalid || showSpinner"
          [showSpinner]="showSpinner"
          (loginClick)="selectedStep(0) ? stepper.next() : submitForm()"
        >
        </ds-lib-login-button>
      </ng-template>
      <ng-container *ngIf="selectedStep(1)">
        <button mat-button class="secondary byd-login-button" (click)="stepper.previous()">
          {{ 'dsLibCommon.login.backLogin' | translate }}
        </button>
      </ng-container>
    </ng-template>
    <!-- End login password template-->
    <a mat-button (click)="sendResetEmail()" [ngClass]="{ disabled: loginControl.invalid }">{{
      'dsLibCommon.login.forgotPassword' | translate
    }}</a>
  </div>
  <div class="login-footer">
    <img class="logo" [src]="logos?.footer" />
    <div class="product prevent-select" *ngIf="productName">
      {{ 'dsLibCommon.login.copyright' | translate: { product: productName } }}
    </div>
  </div>
</div>
<div class="right-side"></div>
